'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherRefreshCw } from '@subframe/core';
import { useEffect } from 'react';
import { Alert, Button, Skeleton } from '@/shared/components/ui';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchTrialsByTenant, selectTrialsByTenantId, selectTrialsError, selectTrialsLoading } from '../store';
import { HistoricoTrialTimeline } from './HistoricoTrialTimeline';
interface HistoricoTrialTabProps {
  tenantId: string;
}
export function HistoricoTrialTab(t0) {
  const $ = _c(16);
  const {
    tenantId
  } = t0;
  const dispatch = useAppDispatch();
  let t1;
  if ($[0] !== tenantId) {
    t1 = selectTrialsByTenantId(tenantId);
    $[0] = tenantId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const trials = useAppSelector(t1);
  const loading = useAppSelector(selectTrialsLoading);
  const error = useAppSelector(selectTrialsError);
  let t2;
  let t3;
  if ($[2] !== dispatch || $[3] !== tenantId) {
    t2 = () => {
      dispatch(fetchTrialsByTenant(tenantId));
    };
    t3 = [dispatch, tenantId];
    $[2] = dispatch;
    $[3] = tenantId;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (loading && trials.length === 0) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="flex flex-col gap-3 pt-2"><Skeleton variant="rectangular" height={72} className="rounded-[16px]" /><Skeleton variant="rectangular" height={160} className="rounded-[16px]" /><Skeleton variant="rectangular" height={120} className="rounded-[16px]" /></div>;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  if (error) {
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <FeatherRefreshCw />;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== dispatch || $[9] !== tenantId) {
      t5 = <Button variant="neutral-secondary" size="small" icon={t4} onClick={() => dispatch(fetchTrialsByTenant(tenantId))}>Tentar novamente</Button>;
      $[8] = dispatch;
      $[9] = tenantId;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== error || $[12] !== t5) {
      t6 = <div className="flex flex-col gap-4 pt-2"><Alert variant="error" title={"Erro ao carregar hist\xF3rico de trial"} description={error} actions={t5} /></div>;
      $[11] = error;
      $[12] = t5;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    return t6;
  }
  let t4;
  if ($[14] !== trials) {
    t4 = <div className="pt-2"><HistoricoTrialTimeline trials={trials} /></div>;
    $[14] = trials;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}